import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'
import { ValList } from '@/common/val/ValList'
import { IncCondList } from '../incCond/IncCondList'

export const IncRuleDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'incCondTab', label: 'Inclusion Conditions', content: <IncCondList incRuleId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INC_COND" parentEntityId={entityObj.id} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}